import { Button } from '@/components/shadcn/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { useRestClient, RestSchemas } from '@/contexts/QueryProvider'
import { AppEntityTypeFormV2 } from '@/pages/Applications/Forms/AppEntityTypeFormV2'
import { IconDeleteOutline } from '@icons/IconDeleteOutline'
import { IconEditOutline } from '@icons/IconEditOutline'
import { IconMenuOutline } from '@icons/IconMenuOutline'
import { toast } from 'sonner'

type MessagesEntityTypesExistingEntityType = RestSchemas['Messages.EntityTypes.ExistingEntityType']

export function EntityCardActionsMenuV2({ entityType }: { entityType: MessagesEntityTypesExistingEntityType }) {
  const { deleteEntityTypeApiDeleteEntityType, getEntityTypeApiGetEntityTypesByApplicationId } = useRestClient()
  const { applicationId, id } = entityType

  const invalidateEntityTypes = () => {
    getEntityTypeApiGetEntityTypesByApplicationId.invalidateQueries({ parameters: { path: { applicationId } } })
  }

  const { mutate: deleteEntityType, isPending: isDeleting } = deleteEntityTypeApiDeleteEntityType.useMutation(
    { path: { id } },
    {
      onSuccess: () => {
        invalidateEntityTypes()
        toast.success('Entity type successfully deleted')
      },
      onError: () => {
        toast.error('Error deleting entity type')
      },
    }
  )

  return (
    <DropdownMenu
      onOpenChange={(open) => {
        // This is necessary to maintain the open state when we want to keep it open
        if (!open) {
          // Check if we need to prevent closing
          // This is a placeholder for custom logic you might need
          // We'll use other mechanisms to prevent closing on item click
        }
      }}
    >
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" className="size-8">
          <IconMenuOutline size={16} />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        onCloseAutoFocus={(e) => {
          // Prevent focus returning to trigger which can close the menu
          e.preventDefault()
        }}
      >
        <DropdownMenuLabel>Actions</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <AppEntityTypeFormV2
          selectedEntityType={entityType}
          sheetTitle="Edit Entity Type"
          sheetDescription="Edit the entity type"
          sheetTrigger={
            <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
              <div className="flex items-center gap-2">
                <IconEditOutline size={16} />
                <span>Edit entity type</span>
              </div>
            </DropdownMenuItem>
          }
        />
        <ConfirmDialog
          title="Confirm Delete"
          description="Are you sure you want to delete this entity type?"
          onConfirm={deleteEntityType}
          trigger={
            <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
              <div className="flex items-center gap-2">
                <IconDeleteOutline size={16} />
                <span>Delete entity type</span>
              </div>
            </DropdownMenuItem>
          }
        />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
